<template>
  <a-form-model ref="collectionsForm" :model="form" :rules="rules" class="collectionsModal">
    <a-form-model-item v-if="mode === 'create'" ref="name" label="Name" prop="name">
      <a-input v-model="form.name" :disabled="loading" placeholder="Collection name" />
    </a-form-model-item>
    <a-form-model-item ref="searchingValues" label="Item value" prop="searchingValues">
      <a-select v-model="form.searchingValues" mode="tags" :disabled="loading" @focus="onChangeValues" @blur="onEndValueEnter">
        <template #placeholder><span style="color: #a1a1c2;">Enter query attributes (login, mail, etc.)</span></template>
        <a-select-option v-for="option in options" :key="option.value">
        {{ option.name}}
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <hr>
    <a-row>
      <a-col class="text-right" :span="24">
        <a-button @click="closeModal" :loading="loading">
          Cancel
        </a-button>
        <a-button type="primary" style="margin-left: 10px;" @click="onSubmit" :disabled="isSaveDisabled" :loading="loading">
          Confirm
        </a-button>
      </a-col>
    </a-row>
  </a-form-model>
</template>
<script>

import CollectionsService from '@/services/api/apiCollectionsService'

export default {
  name: 'CollectionModal',
  components: {
  },
  props: {
    mode: {
      type: String,
      default: 'create',
    },
    collectionId: {
      type: String,
    },
  },
  data() {
    return {
      form: {
        name: '',
        searchingValues: [],
      },
      loading: false,
      rules: {
        name: [{ required: true, message: 'Please input collection name', trigger: 'blur' }],
        searchingValues: [{ type: 'array', required: true, message: 'Please input collection search attributes', trigger: 'change' }],
      },
      options: [
      ],
      isSaveDisabled: false,
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    closeModal() {
      this.$emit('closeCollectionModal')
    },
    async onSubmit() {
      const isValid = await new Promise((resolve) => {
        this.$refs.collectionsForm.validate(resolve)
      })
      if (!isValid) {
        return false
      }
      return this.mode === 'create' ? await this.createCollection() : await this.addCollectionItem()
    },
    onChangeValues() {
      this.isSaveDisabled = true
    },
    onEndValueEnter() {
      this.isSaveDisabled = false
    },
    async createCollection() {
      this.loading = true
      try {
        const payload = {
          name: this.form.name,
          searching_values: this.form.searchingValues,
        }
        const collectionsResponse = await CollectionsService.createCollection(payload)

        if (collectionsResponse.data?.error) {
          this.$notification.error({
            message: 'Something went wrong',
            description: collectionsResponse.data.error.message,
          })
          return
        }

        if (collectionsResponse.data.data) {
          this.$notification.success({
            message: 'Collection has been successfully created',
          })
          this.$emit('addNewCollection', collectionsResponse.data.data)
        }
      } catch (err) {
        this.$notification.error({
          message: 'Something went wrong',
          description: err.response.data.error.message,
        })
        console.log(err)
      } finally {
        this.loading = false
      }
    },
    async addCollectionItem() {
      this.loading = true
      try {
        const payload = {
          items: this.form.searchingValues,
        }
        const collectionsResponse = await CollectionsService.createCollectionItem(this.collectionId, payload)

        if (collectionsResponse.data?.error) {
          this.$notification.error({
            message: 'Something went wrong',
            description: collectionsResponse.data.error.message,
          })
          return
        }

        if (collectionsResponse.data.data) {
          this.$notification.success({
            message: 'Collection item has been added successfully',
          })
          this.$emit('addNewItem', collectionsResponse.data.data)
        }
      } catch (err) {
        this.$notification.error({
          message: 'Something went wrong',
          description: err.response.data.error.message,
        })
        console.log(err)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
<style scoped lang="scss">
</style>
